import { Component, Prop, VModel, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

@Component({
    components: {
        ValidationProvider
    }
})
export default class CustomerNotes extends Vue {
    @VModel()
    customerNotes : string;

    @Prop({ default: 'customer-notes-input' })
    id: string;

    @Prop({ default: ''})
    label: string;

    @Prop({ default: ''})
    rules: string;
}
